// GRPC Error Code Standard: https://grpc.github.io/grpc/core/md_doc_statuscodes.html

export const GRPC_ERROR_CODES = {
    INVALID_ARGUMENT: 3,
    NOT_FOUND: 5,
    PERMISSION_DENIED: 7,
    RESOURCE_EXHAUSTED: 8,
    INTERNAL: 13,
};
